import React, { useEffect } from "react";
import htmlParser from 'react-html-parser';
import { VscArrowSmallRight } from "react-icons/vsc";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { allBlogsForRecent, allBlogsForSlider, getBlogsByPagination } from "../../../redux/actions/frontendActions/blogActions";
function HomeBlog() {
  const dispatch = useDispatch();


  const { allblogs,  recentPost } = useSelector(
    (state) => state.Blog
  );

  useEffect(() => {
    dispatch(allBlogsForSlider());
    dispatch(allBlogsForRecent());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() =>{
    dispatch(getBlogsByPagination());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div className="home-blog-wrapper">
      <div className="top-area">
        <h1>Journal</h1>
        <p>Digitalization, Startups, Fintech and more</p>
      </div>

      <div className="home-blogs">
        {
          recentPost.length > 0? recentPost.slice(0 ,1).map((p, i) =>  <Link key={i} to={`/blog/${p._id}`} className="left">
          <div className="img-area">
            <img src={p.image} alt="img" />
          </div>
          <div className="text-area">
            <h3>
             {p.title}
            </h3>
            <p>{htmlParser(p?.description.slice(0 , 120))}</p>
          </div>
        </Link> ) : <h1>Loading...</h1>
        }
       
        <div className="right">
          <div className="right-blog-flex">
          {
            allblogs.length> 0? allblogs.slice(0 ,3).map((p ,i) => <Link key={i} to={`/blog/${p._id}`} className="blog">
            <div className="img">
              <img src={p.image} alt="" />
            </div>
            <div className="text">
              <h3>{p.title}</h3>
              <p>{htmlParser(p?.description.slice(0 , 150))}.... </p>
            </div>
          </Link> ) : <h1>Loading...</h1>
          }

            

          



          </div>
        </div>
      </div>
      <div className="button-area">
        <Link to="/blogs">
          <button>
            Go to Megazine <VscArrowSmallRight size={25} />
          </button>
        </Link>
      </div>
    </div>
  );
}

export default HomeBlog;
